import filtersToQuery from './filtersToQueryParameters';
import { Filter } from '../../../domain/Filter';
import combineQueryParameters from './combineQueryParameters';
import { ProductChannelStatus } from '../../../domain/Product';

export default (status: ProductChannelStatus, searchQuery: string, filters: Filter[]): string => {
    const parameters: string[] = [`status=${status}`];
    if (searchQuery !== '') {
        parameters.push(`query=${searchQuery}`);
    }
    parameters.push(...filtersToQuery(filters));
    return combineQueryParameters(parameters);
};



// WEBPACK FOOTER //
// ./src/application/products/epic/productQueryFactory.ts